module.exports = __webpack_public_path__ + "static/media/nlu.a92484c2.svg";